import { queryOptions, useQuery } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import { getPetTypesRequest } from "lib/api/reference/petType";
import type { PetTypeInterface } from "types/reference";

export const petTypeReferenceKeys = {
    all: ["reference", "pet-type"] as const,
    list: (languageCode: string) => [...petTypeReferenceKeys.all, "list", languageCode] as const,
};

export const fetchPetTypes = (languageCode: string) =>
    parseResponse<Array<PetTypeInterface>>(getPetTypesRequest(languageCode));

export const petTypeReferenceQueryOptions = (languageCode: string) =>
    queryOptions<Array<PetTypeInterface>>({
        queryKey: petTypeReferenceKeys.list(languageCode || "__missing__"),
        queryFn: () => fetchPetTypes(languageCode),
        enabled: Boolean(languageCode),
    });

export const usePetTypes = (languageCode: string) => useQuery(petTypeReferenceQueryOptions(languageCode));
